import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { TableLine } from "../../common/Style";
import sideTable from "../../../assets/common/sideTable.svg";
import checkSign from "../../../assets/common/checkSign.svg";
import {
  edit,
  editArrival,
  editArrived,
  editMany,
} from "../../../store/reducers/guestsReducer";
import { toast } from "react-toastify";
import { sendGenericSms } from "../../../store/reducers/dataReducer";

const TrTables = (props) => {
  const dispatch = useDispatch();
  const { user, isTal } = useSelector((state) => state.authReducer);
  const [showEditTable, setShowEditTable] = useState(false);
  const [table, setTable] = useState(null);

  const handleSendTable = async (phone, msg) => {
    let body = {
      Data: {
        Message: "[#msg#]",
        Recipients: [
          {
            msg: msg,
            Phone: phone,
          },
        ],
        Settings: {
          Sender:
            user.producer == "משחק הכיסאות"
              ? "ChairsGame"
              : user.producer == "מארגנת החתונות"
              ? "WedPlanner"
              : user.producer == "שמחת עולם"
              ? "SimhatOlam"
              : user.producer == "דובי הפקות"
              ? "DubiProd"
              : user.producer == "אל על"
              ? "EL_Al"
              : user.producer == "קליקסיט"
              ? "ClickSeat"
              : user.producer == "PM ניהול והפקות אירועים"
              ? "PM_Events"
              : user.producer,
        },
      },
    };
    dispatch(sendGenericSms(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleEditArrive = async () => {
    let msg;
    if (user.tablesArray[props.data.table - 1].title.split(" ")[0] === "או") {
      const searchRegExp = /[a-zA-Zא-ת]/gi;
      const tables = user.tablesArray[props.data.table - 1].title
        .substring(3)
        .replaceAll(searchRegExp, "")
        .replaceAll(/[^,\d]/g, "");
      // .replaceAll(/[^\d]/g, "")
      msg = `מספרי שולחנות הישיבה שלך הם: ${props.data.table}, ${tables}`;
    } else msg = `מספר השולחן שלך הוא: ${props.data.table}`;
    dispatch(editArrived(props.data._id, { arrived: table })).then(
      async (res) => {
        if (res.payload?.error) {
          toast.error(res.payload?.error);
        } else {
          if (props.data.phone !== null && props.data.phone !== "")
            await handleSendTable(props.data.phone, msg);
          else
            toast.warning(
              "סימון ההגעה נשמר אך לא נשלחה הודעה לאורח מכיוון שאין לו מספר במערכת, יש לתת לו פתק"
            );
          setShowEditTable(false);
        }
      }
    );
  };

  // const handleEditTableMany = async () => {
  //   if (
  //     user.tablesArray[parseInt(table) - 1] !== undefined ||
  //     parseInt(table) == 0
  //   ) {
  //     dispatch(editMany({ ids: [props.data._id], table })).then((res) => {
  //       if (res.payload?.error) toast.error(res.payload?.error);
  //       else {
  //         toast.success("הפועלה בוצעה בהצלחה!");
  //         setShowEditTable(false);
  //       }
  //     });
  //   } else alert("שולחן לא תקין או לא קיים");
  // };

  return (
    <TableLine
      key={props.index}
      onClick={() => {
        if (props.clientMode) props.add_del(props.data._id, props.data.accept);
        else setShowEditTable(!showEditTable);
      }}
      background={props.checked ? "#c1d1eb79" : "inherit"}
      onContextMenu={() => toast.info(`0${props.data.phone}`)}
    >
      <div>
        {showEditTable ? (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <OverlayTrigger
              placement={"bottom"}
              overlay={<Tooltip>{"העברת שולחן"}</Tooltip>}
            >
              <img
                className="animate__animated animate__fadeIn"
                src={sideTable}
                alt="sideTable"
                style={{ cursor: "pointer", width: "22px", marginLeft: "7px" }}
                onClick={() => props.handleEditTable(table, props.data._id)}
              />
            </OverlayTrigger>
            <input
              type="number"
              min="1"
              max="100"
              onChange={(e) => setTable(e.target.value)}
              className="animate__animated animate__fadeIn"
              style={{ padding: "2px 3px" }}
            />
            {isTal && (
              <OverlayTrigger
                placement={"bottom"}
                overlay={<Tooltip>{"סימון הגעה"}</Tooltip>}
              >
                <img
                  className="animate__animated animate__fadeIn"
                  src={checkSign}
                  alt="checkSign"
                  style={{
                    cursor: "pointer",
                    width: "22px",
                    marginRight: "7px",
                  }}
                  onClick={handleEditArrive}
                />
              </OverlayTrigger>
            )}
          </div>
        ) : (
          <div>{props.data.name}</div>
        )}
      </div>
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <div style={{ cursor: "pointer", marginRight: "20px" }}>
          {parseInt(props.data.arrived) >= 0
            ? parseInt(props.data.arrived) + "/" + props.data.accept
            : props.data.accept}
        </div>
      </div>
    </TableLine>
  );
};

export default TrTables;
